import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrgManagementState } from '../reducers/orgmanagement.reducer';

export const orgManagementState: any = createFeatureSelector<OrgManagementState>('orgManagement');

export const orgManagementsData = createSelector(orgManagementState, (state: any) => {
  return state.data;
});

export const orglistForHeader = createSelector(orgManagementState, (state: any) => {
  return state.orglistForHeader;
});

export const selectedOrgDeleted = createSelector(orgManagementState, (state: any) => {
  return state.selectedOrgDeleted;
});

export const orgManagementData = createSelector(orgManagementState, (state: any) => {
  return state.sidOrgManagementData;
});

export const orgDataForHeader = createSelector(orgManagementState, (state: any) => {
  return state.orgDataForHeader;
});

export const orgManagementLoader = createSelector(orgManagementState, (state: any) => {
  return state.loader;
});

export const orgHeaderLoader = createSelector(orgManagementState, (state: any) => {
  return state.orgHeaderLoader;
});

export const searchText = createSelector(orgManagementState, (state: any) => state.searchText);
export const totalRecords = createSelector(orgManagementState, (state: any) => {
  return state.totalRecords;
});
export const testGithubConnectionResponse = createSelector(orgManagementState, (state: any) => {
  return state.testGithubConnectionResponse;
});

export const storeGitTokenResponse = createSelector(orgManagementState, (state: any) => {
  return state.storeGitTokenResponse;
});

export const errorMessage = createSelector(orgManagementState, (state: any) => {
  return state.errorMessage;
});
